<script lang="ts">
  import type { PblContract } from "$lib/types/contracts";
  import { contentBlockComponents } from "$lib/portableText/utils";
  import { breakpoints as br } from "$lib/utils/getBreakpoints";
  import { PortableText } from "@portabletext/svelte";
  import MetaData from "$lib/MetaData.svelte";
  import Picture from "$lib/Picture.svelte";
  import TypeformButton from "$lib/TypeformButton.svelte";

  interface Props {
    data: {
      pbl_contract: Readonly<PblContract>;
    };
  }

  let { data }: Props = $props();

  let typeformUrl = $derived(`https://form.typeform.com/to/euUF2JJe`);
  let contract = $derived(data?.pbl_contract?.contract);
</script>

<MetaData data={{ title: contract.name, description: contract.description }} />

<h1 class="px-edge-x">{contract.name}</h1>

<div class="px-edge-x">
  <p class="text-lead max-w-prose mb-4">{contract.description}</p>
  <div class="flex gap-8 responsive-wrapper text-body">
    <div>
      <PortableText
        value={contract.content}
        components={contentBlockComponents}
        onMissingComponent={false}
      />
      {#if contract.documents && contract.documents.length > 0}
        <ul class="my-8">
          {#each contract.documents as doc (doc)}
            <li>
              <a href={doc.url} target="_blank">{doc.title ?? "Fil uten navn"}</a>
            </li>
          {/each}
        </ul>
      {/if}
      {#if contract.finePrint}
        <div class="max-w-prose my-3 children-my-1 text-base">
          <PortableText
            value={contract.finePrint}
            components={contentBlockComponents}
            onMissingComponent={false}
          />
        </div>
      {/if}
      <p>
        <TypeformButton
          class="button-primary-success"
          url={typeformUrl}
          customParameters={{
            produkt: "PBL Spot",
            product_id: contract.product_id || "",
          }}>Bestill PBL strømavtale</TypeformButton
        >
      </p>
    </div>

    {#if contract.image?.src}
      <Picture
        src={contract.image.src}
        srcset={contract.image.srcset}
        srcsetWebp={contract.image.srcsetWebp}
        alt={contract.image.alt}
        width={contract.image?.asset?.metadata?.dimensions?.width}
        height={contract.image?.asset?.metadata?.dimensions?.height}
        class="object-contain rounded-2xl aspect-square"
        sizes={`(min-width: ${br.desktop}) 20vw, (min-width: ${br.laptop}) 30vw, (min-width: ${br.tablet}) 30vw, (min-width: ${br.mobile}) 90vw, 100vw`}
      />
    {/if}
  </div>
</div>

<style>
  .responsive-wrapper {
    flex-direction: column;
  }
  @media (--laptop) {
    .responsive-wrapper {
      flex-direction: row;
    }
  }
</style>
